var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNose3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.6 31.3",
    style: {
      enableBackground: "new 0 0 42.6 31.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{fill:url(#SVGID_00000006670882217183590440000000475943050697619873_);}\n\t.st2{opacity:0.6;fill:url(#SVGID_00000136374875775176401300000012100885969175257255_);enable-background:new    ;}\n\t.st3{fill:url(#SVGID_00000152984754732145608710000006041001105605155229_);}\n\t.st4{fill:url(#SVGID_00000039839518009827523050000015881866060353401773_);}\n\t.st5{opacity:0.6;fill:url(#SVGID_00000157291740635569317820000007369011919277676700_);enable-background:new    ;}\n\t.st6{opacity:0.6;fill:url(#SVGID_00000182514183642609869010000014712687255027882884_);enable-background:new    ;}\n\t.st7{fill:#FFCEBE;}\n\t.st8{opacity:0.25;fill:url(#SVGID_00000149367037408560125850000010210399327290612357_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.4004,
    y1: 22.0009,
    x2: 21.4004,
    y2: -1.3313,
    gradientTransform: "matrix(1 0 0 -1 0 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.3,22.3c-0.6,0.7-5.4,8.1-19.9,8.1S2.1,23,1.5,22.3c-0.4-0.5-0.1-0.9,4.1-1.2c4.1-0.3,8.9,1.3,9,1.5 c2.4,1.7,10,2,13.7,0c0.1-0.2,4.9-1.7,9-1.5C41.4,21.4,41.7,21.9,41.3,22.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127009997592177063970000007405701501576819355_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.3138,
    y1: 836.4674,
    x2: 21.3138,
    y2: 811.093,
    gradientTransform: "matrix(1 0 0 1 0 -810)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF8881"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3383,
    style: {
      stopColor: "#F99287"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8097,
    style: {
      stopColor: "#F3A987",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2AD87",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127009997592177063970000007405701501576819355_)"
    },
    d: "M38.1,25.9c-4.3,0.7-5-1.1-8.7-1.1 s-4.9,2.4-8.1,2.4s-4.5-2.4-8.1-2.4c-3.7,0-4.4,1.8-8.7,1.1c-3.8-0.7-5.6-9-3.9-14.2l0,0C0.9,11,1.1,10.5,1.4,10 C4.2,5.1,15.6,0,21.3,0s17.2,5.1,20,10c0.4,0.8,0.8,1.7,1,2.6C43.5,17.8,41.7,25.2,38.1,25.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024700127056719167820000000388434896030614697_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.04265025,
    y1: 12.44,
    x2: 42.5752,
    y2: 12.44,
    gradientTransform: "matrix(1 0 0 -1 0 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000024700127056719167820000000388434896030614697_)",
      enableBackground: "new"
    },
    d: " M38.1,25.9c-4.3,0.7-5-1.1-8.7-1.1s-4.9,2.4-8.1,2.4s-4.5-2.4-8.1-2.4c-3.7,0-4.4,1.8-8.7,1.1c-3.8-0.7-5.6-9-3.9-14.2 c-0.1,0.5-1.2,5.3,1.1,9.1c0.8,1.4,2.5,1.9,4,1.3c3.4-1.3,10.3-3.5,17.8-2.9c6.2,0.5,10.4,1.7,12.9,2.6c1.7,0.6,3.5-0.2,4.2-1.9 c0.7-1.8,1.5-4.3,1.5-7.4C43.5,17.8,41.7,25.2,38.1,25.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130609463309645218630000001533181141954692539_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.4876,
    y1: 834.9396,
    x2: 14.9278,
    y2: 834.9396,
    gradientTransform: "matrix(1 0 0 1 0 -810)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8D2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130609463309645218630000001533181141954692539_)"
    },
    d: "M6.1,26c-2.1-0.2,1-3.9,8.8-1.1 C14.9,25,7.7,26.2,6.1,26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120519428194297864230000013081273847060158610_",
    gradientUnits: "userSpaceOnUse",
    x1: -11761.0234,
    y1: 835.0899,
    x2: -11751.6025,
    y2: 835.0899,
    gradientTransform: "matrix(-1 0 0 1 -11723.792 -810)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8D2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120519428194297864230000013081273847060158610_)"
    },
    d: "M36.6,26c2.1-0.2-1.2-3.2-8.8-1.1 C27.8,25,35,26.2,36.6,26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168088446655938808100000004746883565389536948_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.7437,
    y1: 821.0748,
    x2: 5.7437,
    y2: 815.9299,
    gradientTransform: "matrix(1 0 0 1 0 -810)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D077F3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000168088446655938808100000004746883565389536948_)",
      enableBackground: "new"
    },
    d: " M2.1,8.9C5,7.7,7.4,10.6,9,11.6c1.5,1-1.6-3.5-5.1-4.5L2.1,8.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155123914827196976910000001500301524042895759_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.9066,
    y1: 821.0748,
    x2: 36.9066,
    y2: 815.9299,
    gradientTransform: "matrix(1 0 0 1 0 -810)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D077F3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000155123914827196976910000001500301524042895759_)",
      enableBackground: "new"
    },
    d: " M40.5,8.9c-2.9-1.2-5.3,1.7-6.8,2.8c-1.5,1,1.6-3.5,5.2-4.5L40.5,8.9z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25.4,13.6c-0.3,0.7-0.9,2.9,0.8,3.1c1.7,0.2,3.5-1,3.7-1.6c0.2-0.5-0.1-2.1-1.4-2.3S25.9,12.4,25.4,13.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099660223510292646660000000604890368906539683_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.0354,
    y1: 12.9069,
    x2: 21.0354,
    y2: 31.8002,
    gradientTransform: "matrix(1 0 0 -1 0 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000099660223510292646660000000604890368906539683_)",
      enableBackground: "new"
    },
    d: " M29.2,18.3c0-0.7,2.4-18.7-8.3-18.2s-7.9,17.2-8,18.2C12.8,19.4,29.2,19,29.2,18.3z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose3);
export default __webpack_public_path__ + "static/media/Nose3.3d62823ff3fcc1df3f3d256058978479.svg";
export { ForwardRef as ReactComponent };